import styled from "styled-components";
import colors from "../../styles/colors";

export const LoginPageWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: #0B172A;
  box-sizing: border-box;
  overflow: hidden;
`;

export const BackgroundImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center right;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  pointer-events: none;
  background: linear-gradient(
    to right,
    #0B172A 0%,
    #0B172A 30%,
    rgba(11, 23, 42, 0.8) 45%,
    rgba(11, 23, 42, 0.3) 65%,
    rgba(11, 23, 42, 0) 85%
  );
`;

export const YaelLogo = styled.img`
  max-width: 380px;
  width: 30%;
  left: 60%;
  top: 18%;
  position: absolute;
  object-fit: contain;
  filter: drop-shadow(0px 6px 16px rgba(0, 0, 0, 0.6));
  z-index: 3;
`;

export const FormWrapper = styled.div`
  width: 320px;
  box-sizing: border-box;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const ErrorMessage = styled.div`
  width: 100%;
  box-sizing: border-box;
  color: #f44f0b;
  font-size: 1rem;
  font-weight: normal;
  text-align: right;
`;

export const Title = styled.div`
  font-size: 0.9rem;
  color: ${colors.theme.yaelWhite};
  text-align: right;
  padding-top: 8px;
`;

export const LoginForm = styled.form`
  position: absolute;
  box-sizing: border-box;
  height: 100%;
  width: 50%;
  left: 0;
  top: 0;
  z-index: 2;
  background: transparent;
  border: none;
  box-shadow: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  button {
    margin-top: 12px;
    background-color: #00A7E3 !important;
    color: #ffffff !important;
    border-radius: 6px;
    font-weight: 600;
    transition: background-color 0.2s ease;
    &:hover {
      background-color: #0088b9 !important;
    }
  }
`;

export const LinkButton = styled.div`
  box-sizing: border-box;
  text-decoration: underline;
  font-size: 1rem;
  color: #00A7E3;
  font-weight: normal;
  text-align: center;
  transition: color 0.3s linear;
  cursor: pointer;
  margin-top: 8px;
  &:hover {
    color: #0088b9;
  }
`;
